<template>
  <modal
    ref="addMeasurer"
    :ok-disabled="loading"
    :ok-title="!id ? 'Pridať' : 'Upraviť'"
    :title="!id ? 'Pridať meradlo' : 'Upraviť meradlo'"
    cancel-title="Zrušiť"
    full-height
    name="add-measurer"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="save"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-form-group
              label-cols-sm="5"
              label="Sériové číslo"
              label-for="serialNumber"
            >
              <b-form-input
                v-model="form.serialNumber"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('serialNumber') }"
                data-vv-as="Sériové číslo"
                name="serialNumber"
              />
              <b-form-invalid-feedback>
                {{ errors.first('serialNumber') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Stav" label-for="state">
              <b-form-select
                v-model="form.isActive"
                :select-size="1"
                name="state"
              >
                <option :value="true">Aktívne</option>
                <option :value="false">Neaktívne</option>
              </b-form-select>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Fakt. násobiteľ"
              label-for="multiplier"
            >
              <b-form-select
                v-model="form.invoiceMultiplier"
                :select-size="1"
                name="multiplier"
              >
                <option :value="1">1</option>
                <option :value="1.5">1,5</option>
                <option :value="2">2</option>
              </b-form-select>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Názov OM - Koncový odberateľ"
              label-for="name"
            >
              <b-form-input
                v-model="form.name"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('name') }"
                data-vv-as="Názov OM"
                name="name"
              />
              <b-form-invalid-feedback>
                {{ errors.first('name') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Sekcia" label-for="section">
              <b-form-input v-model="form.section" name="section" />
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Podlažie" label-for="floor">
              <b-form-input v-model="form.floor" name="floor" />
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Typ merania"
              label-for="measureType"
            >
              <b-form-input
                v-model="form.measureType"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('measureType') }"
                data-vv-as="Názov OM"
                name="measureType"
              />
              <b-form-invalid-feedback>
                {{ errors.first('measureType') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Poznámka" label-for="note">
              <b-form-textarea v-model="form.note" rows="2" name="note" />
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import operationService from '@/services/api/operationService'

export default {
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
      id: null,
      form: {},
    }
  },
  methods: {
    fetchData() {
      if (this.id) {
        this.loading = true
        operationService.getDevice(this.id).then((res) => {
          this.form = res.data
          this.loading = false
        })
      }
    },
    save(e) {
      e.preventDefault()
      this.$validator.validateAll().then(() => {
        if (!this.errors.any() && !this.loading) {
          if (this.id) {
            operationService.updateDevice(this.id, this.form).then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: 'Meradlo bolo upravené',
                timer: 5000,
              })
              this.$root.$emit('modal-hide', 'add-measurer')
              this.$root.$emit('operation.reloadDeviceData')
            })
          } else {
            operationService.createDevice(this.form).then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              }).catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba',
                  timer: 5000,
                })
              })
              this.$root.$emit('modal-hide', 'add-measurer')
              this.$root.$emit('operation.reloadDeviceData')
            })
          }
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
